import { MatchResultsForUser } from '@fantaz/shared/data-access/models';
import { Action, createReducer, on } from '@ngrx/store';

import * as GameHistoryDetailsActions from './game-history-details.actions';

export const GAME_HISTORY_DETAILS_FEATURE_KEY = 'gameHistoryDetails';

export interface gameHistoryDetailState {
  matchResultsForUser: MatchResultsForUser | null;
  userPlays?: string[];
  loaded: boolean; // has the GameHistory list been loaded
  error?: string | null; // last known error (if any)
  total: number;
}

export interface GameHistoryDetailsPartialState {
  readonly [GAME_HISTORY_DETAILS_FEATURE_KEY]: gameHistoryDetailState;
}

export const initialState: gameHistoryDetailState = {
  // set initial required properties
  loaded: false,
  total: 0,
  matchResultsForUser: null,
};

const gameHistoryDetailsReducer = createReducer(
  initialState,
  on(GameHistoryDetailsActions.loadGameHistoryDetail, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(
    GameHistoryDetailsActions.loadGameHistoryDetailsSuccess,
    (state, { gameHistoryDetails }) => ({
      ...state,
      loaded: true,
      matchResultsForUser: gameHistoryDetails.matchResultsForUser,
      total: gameHistoryDetails.total,
      userPlays: gameHistoryDetails.currentUserPlays,
    }),
  ),
  on(GameHistoryDetailsActions.clearGameHistoryDetails, (state) => {
    return {
      ...state,
      entities: null,
      loaded: false,
      error: null,
    };
  }),
  on(
    GameHistoryDetailsActions.loadGameHistoryDetailsFailure,
    (state, { error }) => ({ ...state, error }),
  ),
);

export function reducer(
  gameHistoryDetailState: gameHistoryDetailState | undefined,
  action: Action,
) {
  return gameHistoryDetailsReducer(gameHistoryDetailState, action);
}
